export const getBadgeClass = (variant) => {
  switch (variant) {
    case "sale":
      return "bg-light-pink"
    case "christmas":
      return "bg-emerald text-white"
    case "sky":
      return "bg-sky text-white"
    case "deal":
      return "bg-[#FBE3E3]"
    case "kid":
      return "bg-[#DCD2E7]"
    case "vday":
      return "bg-[#F2F2F2]"
    case "xmas_delivery":
      return "bg-garnet text-white"
    case "lee_fiori":
      return "bg-[#EEEDE6]"
    case "best_deal":
      return "bg-black-print text-white"
  }

  return null
}
